export const content = {
  voicePlansCategoryTitle: 'Rolling Monthly',
  voicePlansCategoryDescription: 'Unlimited calls & texts',
  dataOnlyPlansCategoryTitle: 'Data Only plans',
  dataOnlyPlansCategoryDescription: 'Just great value data',
  dataDiscountPlansCategoryTitle: 'Data Discount plans',
  dataDiscountPlansCategoryDescription: 'Get money back for unused data',
  placeholder: 'Select a plan',
}
